import { Component, HostListener } from '@angular/core';
import { MenuPrincipalComponent } from './shared/menu-principal/menu-principal.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'datalaing';

  constructor(
    private menuPrincipalComponent: MenuPrincipalComponent) { }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    event.preventDefault();
  }
}
